import WorkEntry from '../components/Work/WorkEntry';

export default function WorkPage() {
    return (
        <div className="WorkPage">
            <WorkEntry />
        </div>
    );
}
